module.exports = __webpack_public_path__ + "static/media/body-bg-6.67e9c0a8.jpg";